import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { globalErrorHandler } from '../../utils/GlobalErrorHandler';
import { formatDate } from '../../utils/dateUtils';


const Dashboard = () => {
  const navigate = useNavigate();
  const [paid, setPaid] = useState([]);
  const [upcoming, setUpcoming] = useState([]);

  const [stats, setStats] = useState({
    total_properties: 0,
    total_beds: 0,
    occupied_beds: 0,
    available_beds: 0,
    users_count: {},
  });

  useEffect(() => {
    fetchStats();
    getPaidPayments();
    getUpcomingPayments();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_WEB_SERVICES_URL}/assistant-manager/get-dashboard-stats`,
        { withCredentials: true }
      );
      setStats(response.data);
    } catch (error) {
      globalErrorHandler(error, navigate);
    }
  };

  

  const formatDateRange = (startDate, monthsPaid) => {
    const start = new Date(startDate);
    const end = new Date(start);
    end.setMonth(end.getMonth() + monthsPaid);
     const format = (date) =>
  date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short", // <-- changes "11" to "Nov"
    day: "2-digit",
  });
    return `(${format(start)} - ${format(end)})`;
  };

  const getUpcomingPayments = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_WEB_SERVICES_URL}/assistant-manager/get-upcoming-payments`,
        {
          params: { name: '', room: '' },
          withCredentials: true,
        }
      );
      setUpcoming(res.data.upcoming || []);
    } catch (err) {
      console.error("Error fetching upcoming payments:", err);
    }
  };

  const getPaidPayments = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_WEB_SERVICES_URL}/assistant-manager/get-paid-payments`,
        {
          params: { page: 1, searchName: "", searchRoom: "" },
          withCredentials: true,
        }
      );
      if (res.data.status) {
        setPaid(res.data.paid || []);
      } else {
        setPaid([]);
      }
    } catch (err) {
      console.error("Error fetching payments:", err);
      setPaid([]);
    }
  };

  return (
    <main className="app-main">
      <div className="app-content-header py-3 bg-light border-bottom shadow-sm">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-sm-6">
              <h3 className="mb-0 text-dark">Dashboard</h3>
            </div>
          </div>
        </div>
      </div>

      <div className="app-content py-4">
        <div className="container-fluid">
          <div className="row g-3">
            {/* Users Box */}
            <div className="col-12 col-md-6">
              <div className="small-box bg-info text-dark rounded-3 shadow-sm h-100 d-flex flex-column">
                <div className="inner px-4">
                  <div className="row">
                    <div className="col-6">
                      <h3 className="text-white fw-bold">
                        {(stats?.users_count?.manager || 0) +
                          (stats?.users_count?.assistant_manager || 0) +
                          (stats?.users_count?.overseer || 0) +
                          (stats?.users_count?.guest || 0)}
                      </h3>
                      <div className="text-white fw-bold">Total Users</div>
                    </div>
                    <div className="col-6">
                      <h3 className="text-white fw-bold">
                        {stats?.users_count?.manager || 0}
                      </h3>
                      <div className="text-white fw-bold">Managers</div>
                    </div>
                  </div>
                </div>

                <div className="inner mt-auto px-4">
                  <div className="row">
                    <div className="col-6">
                      <h3 className="text-white fw-bold">
                        {stats?.users_count?.assistant_manager || 0}
                      </h3>
                      <div className="text-white fw-bold">Assistant Managers</div>
                    </div>
                    <div className="col-6">
                      <h3 className="text-white fw-bold">
                        {stats?.users_count?.overseer || 0}
                      </h3>
                      <div className="text-white fw-bold">Overseers</div>
                    </div>
                  </div>
                </div>

          
              </div>
            </div>

            {/* Beds / Properties Box */}
            <div className="col-12 col-md-6">
              <div className="small-box bg-success text-dark rounded-3 shadow-sm h-100 d-flex flex-column">
                <div className="inner px-4">
                  <div className="row">
                    <div className="col-6">
                      <h3 className="text-white fw-bold">{stats?.total_beds}</h3>
                      <div className="text-white fw-bold">Total Beds</div>
                    </div>
                    <div className="col-6">
                      <h3 className="text-white fw-bold">{stats?.total_properties}</h3>
                      <div className="text-white fw-bold">Total Properties</div>
                    </div>
                  </div>
                </div>

                <div className="inner mt-auto px-4 ">
                  <div className="row">
                    <div className="col-6">
                      <h3 className="text-white fw-bold">{stats?.occupied_beds}</h3>
                      <div className="text-white fw-bold">Occupied Beds</div>
                    </div>
                    <div className="col-6">
                      <h3 className="text-white fw-bold">{stats?.available_beds}</h3>
                      <div className="text-white fw-bold">Available Beds</div>
                    </div>
                  </div>
                </div>

            
              </div>
            </div>
          </div>

          {/* Payments Section */}
          <div className="row g-3 mt-3">
            <div className="col-12 col-md-6">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Latest Payments</h3>
                </div>
                <div className="card-body p-0">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Method</th>
                        <th>Room</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paid.length === 0 ? (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No records found
                          </td>
                        </tr>
                      ) : (
                        paid.map((item) => (
                          <tr key={item.id}>
                            <td>{formatDate(item.created_at)}</td>
                            <td className="text-capitalize">{item.method}</td>
                            <td>
                              {item.bedtypename} {item.room_no} {item.property_name} <br />
                              {item.months_paid > 0
                                ? formatDateRange(item.created_at, item.months_paid)
                                : "-"}
                            </td>
                            <td>{`$${Number(item.amount).toFixed(2)}`}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Upcoming Payments</h3>
                </div>
                <div className="card-body p-0">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Due On</th>
                        <th>Due Amount</th>
                        <th>Room</th>
                      </tr>
                    </thead>
                    <tbody>
                      {upcoming.length === 0 ? (
                        <tr>
                          <td colSpan="6" className="text-center">
                            No records found
                          </td>
                        </tr>
                      ) : (
                        upcoming.slice(0, 10).map((item) => (
                          <tr key={item.id}>
                            <td>{formatDate(item.next_due_date)}</td>
                            <td>{`$${Number(item.total_monthly_rent).toFixed(2)}`}</td>
                            <td>
                              {item.bedtypename} {item.room_no} {item.property_name}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Dashboard;
